import * as Yup from "yup"
import { transformSnakeToCamel } from "utils/transform"

/**
 * Sales Schema
 * Represents a order that can be promoted by affiliates
 * Base schema is loose to allow loading legacy data.
 */
export const SalesSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    salesId: Yup.number().nullable(),
    quantity: Yup.number().nullable(),
  })

/**
 * Sales Validation Schema
 * Strict rules applied only during form submission.
 */
export const SalesValidationSchema = SalesSchema.clone().shape({
  salesId: Yup.number().required(),
  quantity: Yup.number().required().min(1, "Quantity must be at least 1"),
})
